import { CustomInputProps } from '@dynamika-shared/ui/Input/Input';
import { CustomSelectProps } from '@dynamika-shared/ui/Select/Select';
import { DefaultOptionType } from 'antd/es/select';

export const selectProps: Partial<CustomSelectProps> = {
  showSearch: false,
  filterOption: (input: string, option: DefaultOptionType | undefined) =>
    option ? ((option.label ?? '') as string).toLowerCase().includes(input.toLowerCase()) : false,
  listHeight: 160,
  classNameLabel: 'pl-1.5',
  className: 'mt-0 min-w-[20.6rem]',
};
export const inputProps: Partial<CustomInputProps> = {
  classNameLabel: 'pl-1.5 mt-[19px] ',
  className: 'flex',
};

